(() => {
  const settingsEl = document.getElementById('rv-settings');
  if (!settingsEl) return;

  const settings = JSON.parse(settingsEl.textContent || '{}');
  const key = 'rv_handles';
  const current = settings.current_handle;

  const tAdd    = settings.text_add_to_cart    || 'Add to cart';
  const tAdded  = settings.text_added          || 'Added';
  const tChoose = settings.text_choose_options || 'Choose options';

  // Locale-aware root so cards render in the storefront language (e.g. /bg/)
  const rawRoot =
    (window.Shopify && Shopify.routes && Shopify.routes.root) ||
    (window.Shopify && Shopify.locale && Shopify.locale !== 'en' ? '/' + Shopify.locale + '/' : '/');
  const localePrefix = rawRoot.replace(/\/+$/, ''); // '' for default, '/bg' for Bulgarian

  // Keep history
  let list = [];
  try { list = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { list = []; }
  if (current) {
    list = list.filter(h => h && h !== current);
    list.unshift(current);
  } else {
    list = list.filter(Boolean);
  }
  list = Array.from(new Set(list)).slice(0, 20);
  localStorage.setItem(key, JSON.stringify(list));

  const grid = document.getElementById('recently-viewed-grid');
  const section = document.getElementById('recently-viewed-section');
  if (!grid || !section) return;

  const isHome = document.body.classList.contains('template-index') ||
                 document.documentElement.getAttribute('data-theme-template') === 'index';
  const limit = isHome ? (Number(settings.max_home) || 8) : (Number(settings.max) || 4);
  const handles = list.filter(h => h !== current).slice(0, limit);
  if (!handles.length) { section.style.display = 'none'; return; }

  // A handle whose product has since been deleted or renamed does not 404: Shopify
  // follows the store's URL redirect for it, usually to a collection. The redirect
  // does not land on the rv-card template, so the reply is a whole storefront page
  // - doctype, header, nav, footer - and r.ok is still true. Injecting that put an
  // entire page inside one 45% wide carousel cell, which made the cell enormously
  // tall, stretched the flex row to match and left a screen of blank space under
  // the real cards. Anything that is not a bare card fragment is therefore dropped.
  const fetchCardHtml = (handle) =>
    fetch(`${localePrefix}/products/${handle}?view=${settings.view || 'rv-card'}`)
      .then((r) => (r.ok && !r.redirected ? r.text() : ''))
      .then((html) => (/<\s*(?:!doctype|html|head|body)\b/i.test(html) ? '' : html))
      .catch(() => '');

  const insertAfter = (ref, el) => {
    if (ref && ref.parentNode) ref.parentNode.insertBefore(el, ref.nextSibling);
    else if (ref) ref.appendChild(el);
  };

  const addInlineButton = async (wrap, handle) => {
    try {
      // avoid duplicates
      if (wrap.querySelector('.rv-inline-add, .card__quick-add')) return;

      const p = await fetch(`/products/${handle}.js`).then(r => r.json());
      const variants = p.variants || [];
      const firstAvail = variants.find(v => v.available);
      if (!firstAvail) return; // sold out

      const hasMultiple = variants.length > 1 || (p.options || []).length > 1;

      const btnWrap = document.createElement('div');
      btnWrap.className = 'rv-inline-add card__quick-add';
      btnWrap.style.display = 'block';

      if (hasMultiple) {
        const a = document.createElement('a');
        a.href = `${localePrefix}/products/${handle}`;
        a.className = 'button button--secondary button--full-width';
        a.textContent = tChoose;
        btnWrap.appendChild(a);
      } else {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'button button--secondary button--full-width';
        btn.textContent = tAdd;
        btn.addEventListener('click', async () => {
          btn.disabled = true;
          try {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: firstAvail.id, quantity: 1 })
            });
            btn.textContent = tAdded;
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          } catch (e) {
            console.error('Add to cart failed', e);
            btn.disabled = false;
            btn.textContent = tAdd;
          }
        });
        btnWrap.appendChild(btn);
      }

      // Find the info container (cover both Dawn variants)
      const info =
        wrap.querySelector('.card__information') ||
        wrap.querySelector('.card-information')  ||  // ← important new selector
        wrap.querySelector('.card__content')     ||
        wrap;

      // Find the price element (several possibilities across versions)
      const priceEl =
        info.querySelector('.price') ||
        info.querySelector('.price__container') ||
        info.querySelector('[data-price]') ||
        info.querySelector('.card-information__meta') ||
        null;

      if (priceEl) {
        insertAfter(priceEl, btnWrap);
      } else {
        // fall back to putting it at end of info
        info.appendChild(btnWrap);
      }
    } catch (e) {
      console.error('Inline add failed for', handle, e);
    }
  };

  (async () => {
    const dead = [];

    for (const h of handles) {
      const html = (await fetchCardHtml(h)).trim();
      // Drop the handle from the stored history too, so a product that has gone
      // away stops being re-fetched on every page view from now on.
      if (!html) { dead.push(h); continue; }

      const wrap = document.createElement('div');
      wrap.className = settings.item_class || 'grid__item';
      wrap.innerHTML = html;
      grid.appendChild(wrap);

      if (settings.inline_add !== false) await addInlineButton(wrap, h);
    }

    if (dead.length) {
      try {
        localStorage.setItem(key, JSON.stringify(list.filter(h => !dead.includes(h))));
      } catch (e) { /* storage unavailable, nothing to clean up */ }
    }

    if (!grid.children.length) section.style.display = 'none';
  })();
})();
